import React from 'react';
import type { ColDef } from 'ag-grid-community';
import { LopCrudPage } from '../../components/LopCrudPage';
import { getRatingLevels, saveRatingLevelsBatch } from '../../api/ratingLevels';
import type { RatingLevel } from '../../types/RatingLevel';
import { t } from '../../i18n/t';

// Reference/helper table for the prospectus (תשקיפים) report: maps each
// credit-rating notation to a report level code + a rating group. Operator
// edits; Fund Manager views (read-only via the ratingLevels resource
// permission — LopCrudPage gates editing on it).
const ratingLevelsColumnDefs: ColDef<RatingLevel>[] = [
  {
    field: 'recId',
    headerName: t('ratingLevels.columns.recId'),
    width: 110,
    // IDENTITY PK — server-assigned, never edited.
    editable: false,
    cellDataType: 'number',
    sort: 'asc',
  },
  {
    field: 'rating',
    headerName: t('ratingLevels.columns.rating'),
    flex: 1,
    minWidth: 160,
    editable: true,
  },
  {
    field: 'levelCode3',
    headerName: t('ratingLevels.columns.levelCode3'),
    width: 150,
    editable: true,
    // Leading-zero string code (e.g. '070101') — NOT a number column, or the
    // leading zero would be stripped.
  },
  {
    field: 'ratingGroupId',
    headerName: t('ratingLevels.columns.ratingGroupId'),
    width: 150,
    editable: true,
    cellDataType: 'number',
  },
];

const newRatingLevelDefaults = (): Partial<RatingLevel> => ({
  recId: 0,
  rating: '',
  levelCode3: '',
  ratingGroupId: 0,
});

export function RatingLevelsPage() {
  return (
    <LopCrudPage<RatingLevel>
      resourceCode="ratingLevels"
      titleKey="ratingLevels.pageTitle"
      idField="recId"
      getRows={getRatingLevels}
      saveBatch={(added, modified, deletedIds) =>
        saveRatingLevelsBatch(added, modified, deletedIds as number[])
      }
      columnDefs={ratingLevelsColumnDefs}
      newRowDefaults={newRatingLevelDefaults}
    />
  );
}
